module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?27cb2cf143cf204f7cfc210089fd10e8";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.woff2?v=4.5.95
// module id = FtfR
// module chunks = 1